<template>
  <Head title="Playbook Type Editor" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <playbook-type-details 
            :playbook_type="playbook_type" 
            :asset_types="asset_types"
            :template_segments="template_segments"
          ></playbook-type-details>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  playbook_type: Object,
  asset_types: Array,
  template_segments: {
    type: Array,
    default: null
  }
});
</script>

